export class transferenceData {
    public currentExportNum: string;
    public newExportNum: string;
    public currentSupplyNum:string| null;
    public newSupplyNum: string|null;
   
}
